import React, { useState, useEffect, useMemo } from 'react';
import { Tabs, Tab, Box, Typography, Button, Grid, FormControl, InputLabel, Select, MenuItem, Tooltip, Popover, IconButton, useTheme, useMediaQuery } from '@mui/material';
import { Section } from '../../../components/InterfaceInfo';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, SelectChangeEvent, ListItemButton } from '@mui/material';
import { QueryStats, Close, Done, ReadMoreOutlined, Recommend, InfoOutlined } from "@mui/icons-material";
import { ReactNode } from 'react';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { updateInputParameters, updateNetwork, deletePermenantData, useStoredAllData, useStoredParameters, getInputParamsFromApi, useInputParams, updateSelectedSection, useStored, useResponseSchema,  getSavedParameterDetails, useNetworkLoaded, deleteAllPermenantLocData, delteGlobalSettings } from '../../../state/services';
import { useInputParamState } from '../../../state/Input-param-state';
import { useNetwork } from '../../../state/services';
import { useOktaAuth } from '@okta/okta-react';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined';
import networkData from '../../../sampledata/SampleNetwork';
import hamburgNetwork from '../../../sampledata/HamburgNetwork';
import ustiBrandysNetwork from '../../../sampledata/UstiBrandys';
import benidormDeniaNetwork from '../../../sampledata/BenidormDenia';
import { List } from '@mui/material'
import { SectionData } from '../../../api-request/api-request';
import { DynamicInputParameters, ParameterGroup } from '../../../types/ApiData';
import DynamicInputParameter from './DynamicInputParameter';
import { useAppPermanentState } from '../../../state/dynamic-perm-state';
import { applySetValueRules, buildDefaultsFromSchema, buildDependencyGraphs, buildResultFromParams, buildRulesMap, buildSetValueDependencyGraph, FormValues, getNetworkName, validateField, ValidationMessage } from '../../../utils/utils';
import { AlertDialogSlide } from '../../../components/SidePanelTab';
import ReusableDialog from '../../../components/Dialog';
import kutnaHoraNetwork from '../../../sampledata/KutnaHora';
import { getNetworkFeatures, useAccessToken, useMode, useOnlineNetworks } from '../../../state/application-state-service';
import { useApplicationState } from '../../../state/application-state';
import { buildValuesForNetwork, buildValuesFromNetworkMetadata } from '../../../utils/onlineMapsUtils';


interface TabPanelProps {
  value: number;
  index: number;
  children: React.ReactNode;
  [key: string]: any;
}


function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default function RightPanelSection({ section, tabs, sectionNumber }: { section: Section, tabs: ReactNode[], sectionNumber: number }) {
  const [value, setValue] = useState(0);


  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto', // Allow scrolling for overflow
      }}
    >
      <Tabs value={value} key={sectionNumber} onChange={handleChange} aria-label="dynamic tabs example" variant="fullWidth" sx={{
        flexShrink: 0,
        borderBottom: 1,
        borderColor: 'divider',
        backgroundColor: 'grey.300',
        fontFamily: {
          'sans': ['Titillium Web', 'Roboto Mono', 'Helvetica', 'Arial', 'sans-serif'],
        },
      }}>
        {section.name_of_dashboards.map((tabName, index) => {
          return (
            <Tab sx={{
              textAlign: 'center',
              padding: 2,
              textTransform: 'none',
              backgroundColor: 'grey.200', // Lighter gray for individual tabs
              '&:hover': {
                backgroundColor: 'grey.300',
              },
              flexGrow: 1,
            }} label={tabName.name} key={index} />
          )
        })}
      </Tabs>
      {tabs.map((item, key) =>
        <TabPanel value={value} index={key} key={key}>
          {item}
        </TabPanel>)
      }

    </Box>
  );
}

export function RightPanelTab({ section, sectionNumber }: { section: Section, sectionNumber: number }) {
  let tab1 = <></>
  let tab2 = <></>
  if (sectionNumber === 0) {
    tab1 = <GlobalSettings />
    tab2 = <>list</>
  } else if (sectionNumber === 1) {
    tab1 = <>content</>
  }
  let tabs = [tab1, tab2]
  return <RightPanelSection key={sectionNumber + 1} sectionNumber={sectionNumber} section={section} tabs={tabs} />

}

const GlobalSettings = () => {
  const [formOpen, setFormOpen] = useState(false)
  const network = useNetwork()
  const [dialogOpen, setDialogOpen] = useState(false);
  const paramState = useInputParamState()
  const storedData = useStoredParameters() as DynamicInputParameters[]
  const [isEdit, setIsEdit] = useState(false)
  const { authState } = useOktaAuth();
  const accessToken = authState?.accessToken?.accessToken || '';
  const storedInputParams = useInputParams()
  const [shouldLoadParams, setShouldLoadParams] = useState(false);
  const networkLoaded = useNetworkLoaded()
  const permenantState = useAppPermanentState()
  const applicationMode = useMode()

  useEffect(() => {
    if (!shouldLoadParams) return;

    if (Object.keys(storedInputParams).length > 0) return;

    getInputParamsFromApi(paramState, accessToken);
  }, [shouldLoadParams]);

  useEffect(() => {
    setShouldLoadParams(true)
  }, [])

  const params =
    network.id
      ? storedData.find(
        (data) => data.id === network.id && data.checked
      ) ?? {}
      : {};

  const storedGlobalData = storedData?.filter(item => (item.id === network.id && item.checked === false)).reverse() || []

  const handleOpen = () => {
    setDialogOpen(true)
  };
  const handleClose = () => setDialogOpen(false);
  const handleEdit = () => {
    setIsEdit(true)
    setFormOpen(true)
  }

  const handleChange = (event: SelectChangeEvent) => {
    if (event.target.value === 'c836c4d1-d36f-4f1f-b957-cbf884b9e1b7') {
      let networkDetails = { id: event.target.value, edgesOfNetwork: networkData.edgesOfNetwork }
      updateNetwork(paramState, networkDetails);
    } else if(event.target.value === 'c878cb04-5f21-4d4e-895f-1f7d6c1b24af') {
      let networkDetails = { id: event.target.value, edgesOfNetwork: hamburgNetwork.edgesOfNetwork }
      updateNetwork(paramState, networkDetails);
    } else if(event.target.value === '5169ee7f-d39b-4b9c-bd31-c382f716f688') {
      let networkDetails = { id: event.target.value, edgesOfNetwork: benidormDeniaNetwork.edgesOfNetwork }
      updateNetwork(paramState, networkDetails);
    } else if(event.target.value === '2d26167a-9bdd-4965-81e6-f5cc33c310e4') {
      let networkDetails = { id: event.target.value, edgesOfNetwork: kutnaHoraNetwork.edgesOfNetwork }
      updateNetwork(paramState, networkDetails);
    } else {
      let networkDetails = { id: event.target.value, edgesOfNetwork: ustiBrandysNetwork.edgesOfNetwork }
      updateNetwork(paramState, networkDetails)
    }
    const network_name = getNetworkName(event.target.value )
    if(!networkLoaded[network_name])
    getSavedParameterDetails(paramState, permenantState, network_name, accessToken, storedInputParams)
    updateSelectedSection(paramState, [])
  };

  const handleEditorAddParams = async () => {
    setFormOpen(true)
  }

  let result: Array<{
    key: string;
    label: string;
    unit?: string;
    type?: number;
    options?: { label: string; value: string }[];
    displayValue: any;
  }> = [];

  if (params && Object.keys(params).length > 0) {
    result = buildResultFromParams(storedInputParams, params)
  }

  let displayItem: Array<{
    key: string;
    label: string;
    unit?: string;
    type?: number;
    options?: { label: string; value: string }[];
    displayValue: any;
  }> = [];

  let displayItemObj: {[key: string]: any} = {};

  if(result.length > 0 ) {
    displayItem = result.filter(item => item.key === 'train_speed' || item.key === 'temperature_air')
    displayItemObj = Object.fromEntries(displayItem.map(item => [item.key, item]));
   }

  return (
    <>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={10}>
          {applicationMode === 'offline' ? <FormControl variant="standard" fullWidth>
            <InputLabel id="select-network-label">Select Network</InputLabel>
            <Select
              labelId="select-network-label"
              id="select-network"
              value={network.id ? network.id : ''}
              onChange={handleChange}
              label="Select Network"
            >
              <MenuItem value="c836c4d1-d36f-4f1f-b957-cbf884b9e1b7">Vossloh Rail Center Hamburg</MenuItem>
              <MenuItem value="c878cb04-5f21-4d4e-895f-1f7d6c1b24af">Hamburg-Kiel</MenuItem>
              <MenuItem value="2d26167a-9bdd-4965-81e6-f5cc33c310e4">Kutna Hora - Malesov</MenuItem>
              <MenuItem value="d347c8f8-1b8e-492a-991c-dc735f63137c">Usti - Brandys</MenuItem> 
              <MenuItem value="5169ee7f-d39b-4b9c-bd31-c382f716f688">Benidorm Denia Line 9</MenuItem>
            </Select>
          </FormControl>
          : <OnlineNetworksDropdown />}
        </Grid>
        <Grid item xs={2}>
          <Button onClick={() => handleEditorAddParams()} variant="outlined" disabled={(network.id && Object.keys(storedInputParams).length > 0) ? false : true}>
            <EditOutlinedIcon />
          </Button>
        </Grid>
        <Grid item xs={12}>
          {(params && (network && params.id === network.id && params.checked === true)) && Object.keys(params).length > 0 &&
            <>
              <ListParameters onClick={handleOpen} data={params} handleEdit={handleEdit} displayItem={displayItemObj} network_id={network.id} />
              {(Object.keys(storedInputParams).length > 0 && result.length > 0 && dialogOpen) && <ReusableDialog open={dialogOpen} cancelText='Close' title='Input Parameter for Global Calculation' content={<DisplayDialog data={result} />} onCancel={() => handleClose()} />}
            </>
          }
        </Grid>
        {/*{(params && (network && params.id === network.id && params.checked === true)) && Object.keys(params).length > 0 &&
          <Grid item xs={12}>
            <DisplayOverview />
          </Grid>
        }*/}
        {(Array.isArray(storedGlobalData) && storedGlobalData.length > 0) &&
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ color: 'green', backgroundColor: '#f4f4f4', padding: 1, borderRadius: 1 }}>
              Previous Global Settings
            </Typography>
          </Grid>}
        <Grid item xs={12}>
          <List>
            {(Array.isArray(storedGlobalData) && storedGlobalData) &&
              (Object.keys(storedInputParams).length > 0) && <ListHistory networkId={network.id} storedInputParams={storedInputParams} storedGlobalData={storedGlobalData} />
            }
          </List>
        </Grid>
        {(Object.keys(storedInputParams).length > 0 && formOpen) && <FormDynamic storedInputParams={storedInputParams} open={formOpen} setFormOpen={setFormOpen} isEdit={isEdit} setIsEdit={setIsEdit} />}
      </Grid>
    </>
  )
}

const ListParameters = ({ onClick, data, handleEdit, displayItem, network_id }: { onClick: () => void, data: DynamicInputParameters, handleEdit: () => void, displayItem: {[key: string]: any}, network_id: string }) => {
  const permanentState = useAppPermanentState();
  const [open, setOpen] = React.useState(false);
  const network_name = network_id ? getNetworkName(network_id) : ''
  const paramState = useInputParamState()
  const { authState } = useOktaAuth();
  const accessToken = authState?.accessToken?.accessToken || '';

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    delteGlobalSettings(permanentState, data, false, paramState, network_name, accessToken, true)
    setOpen(false);
  }

  return <ListItemButton
    sx={{
      bgcolor: '#33ae3319',
      borderBottom: '1px solid #33ae33',
      ":hover": {
        bgcolor: '#33ae3319', borderBottom: '1px solid #33ae33'
      },
      ":nth-of-type(even)": {
        bgcolor: '#33ae3319',
      },
    }}
  >
    <Grid container spacing={1}>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          Train Speed
        </Typography>
        <Typography variant="body2" sx={{ fontSize: 14.5, mt:1 }}>
          {displayItem['train_speed']?.displayValue} {displayItem['train_speed']?.unit}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          Air Temp
        </Typography>
        <Typography variant="body2" sx={{ fontSize: 14.5, mt: 1 }}>
          {displayItem['temperature_air']?.displayValue != null
            ? `${displayItem['temperature_air'].displayValue} ${displayItem['temperature_air']?.unit ?? ""}`
            : "-"}
        </Typography>
      </Grid>      <Grid item xs={2}><br /><Button onClick={onClick} color="primary" sx={{ color: '#388e3c' }}><ViewListOutlinedIcon /></Button></Grid>
      <Grid item xs={2}><br /><Button onClick={(e) => { e.stopPropagation(); handleEdit() }} color="primary" ><EditOutlinedIcon /></Button></Grid>
      <Grid item xs={2}><br /><Button onClick={handleClickOpen} color="error" sx={{ color: '#388e3c' }}><RemoveCircleOutlineIcon color="error" /></Button></Grid>
    </Grid>
    <ConfirmationAlert open={open} handleClose={handleClose} handleSubmit={handleDelete}
      message='This action will clear selected global configuration calculations. This cannot be undone.'
      title='Are you sure you want to reset?'
    />
  </ListItemButton>
}
interface AlertProps {
  open: boolean
  handleClose: () => void
  handleSubmit: () => void
  message: string
  title: string
}

export const ConfirmationAlert = ({ open, handleClose, handleSubmit, message, title }: AlertProps) => {
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" >
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
            <br />
            <Typography fontWeight='bold' color="primary">Do you wish to proceed?</Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' color='error' endIcon={<Close />} onClick={handleClose}>No</Button>
          <Button variant='outlined' color='success' endIcon={<Done />} onClick={handleSubmit} autoFocus>Yes</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

const ListHistory = ({ storedGlobalData, storedInputParams, networkId }: { storedGlobalData: DynamicInputParameters[], storedInputParams: ParameterGroup[], networkId: string }) => {
  const [dialogueDisplay, setDialogueDisplay] = useState(false);
  const [selectedItem, setSelectedItem] = useState<DynamicInputParameters | null | SectionData | { [key: string]: any }>(null);
  const storedDataAll = useStoredAllData()
  const paramState = useInputParamState()
  const permanentState = useAppPermanentState()
  const { authState } = useOktaAuth();
  const accessToken = authState?.accessToken?.accessToken || '';
  const [open, setOpen] = React.useState(false);
  const [isChange, setIsChange] = React.useState(false);
  const [selectedItemResults, setSelectedItemResults] = useState<Array<{
    key: string;
    label: string;
    unit?: string;
    type?: number;
    options?: { label: string; value: string }[];
    displayValue: any;
  }>>([])
  const responseSchema = useResponseSchema()

  // delete open
  const handleClickOpen = (item: DynamicInputParameters) => {
    setSelectedItem(item as DynamicInputParameters | SectionData);
    setOpen(true);
  };

  // delete close
  const handleClose = () => {
    setOpen(false);
    setSelectedItem(null)
  };

  const handleDelete = () => {
    if (selectedItem) {
      deletePermenantData(permanentState, selectedItem as DynamicInputParameters, true)
      setSelectedItem(null)
    }

    setOpen(false);
  }

  // Input Params open
  const handleOpenParamsDialog = (item: DynamicInputParameters) => {
    let result: Array<{
      key: string;
      label: string;
      unit?: string;
      type?: number;
      options?: { label: string; value: string }[];
      displayValue: any;
    }> = []
    if (Object.entries(item).length > 0) {
      if (item && Object.keys(item).length > 0) {
        result = buildResultFromParams(storedInputParams, item)
      }
      setSelectedItemResults(result);
      setDialogueDisplay(true);
    }
  };

  // close dialog input params/ result
  const handleCloseDialog = () => {
    setDialogueDisplay(false);
    setSelectedItemResults([]);
  };

  // result open
  const handleOpenResultDialog = (item: string) => {
    if (storedDataAll[item]) {
      let section = { ...storedDataAll[item]}
      const result = (() => {
        if (Object.keys(section).length === 0) return []
        // Map for fast lookup
        const schemaMap = new Map(responseSchema.map(s => [s.code, s]));

        return Object.entries(section)
          .filter(([key]) => schemaMap.has(key))
          .map(([key, value]) => {
            const schema = schemaMap.get(key)!;

            return {
              key: key,
              code: schema.code,
              label: schema.label,
              hint: schema.hint,
              unit: schema.unit,
              value: value,
              displayValue: value,
            };
          });
      })();
      setSelectedItemResults(result);
      setDialogueDisplay(true);
    }
  }

  // selecting each element from list 
  const handleOpenConfirmation = async (item: DynamicInputParameters) => {
    setSelectedItem(item as DynamicInputParameters | SectionData);
    setIsChange(true)
  }

  const handleUpdateConfig = async () => {
    if (selectedItem) {
      const response = storedDataAll[JSON.stringify(selectedItem as DynamicInputParameters)]
      const networkDetails = {
        network_id: getNetworkName(response.id) ?? "unknown-network",
        coords: response ? { latitude: response?.location.latitude, longitude: response?.location.longitude } : { latitude: 0, longitude: 0 },
        section_id: "global",
      };
      await updateInputParameters(paramState, permanentState, selectedItem as DynamicInputParameters, accessToken, true, storedDataAll[JSON.stringify(selectedItem as DynamicInputParameters)], networkId, storedInputParams, networkDetails)
      setIsChange(false)
      setSelectedItem(null)
    }
  }

  const handleCloseConfirmation = () => {
    setIsChange(false);
    setSelectedItem(null);
  };



  return (
    <>
      {storedGlobalData.map((item, index) => {
        let result: any[] = [];
        let displayItem: Record<string, any> = {};

        if (item && Object.keys(item).length > 0) {
          result = buildResultFromParams(storedInputParams, item);
          displayItem = Object.fromEntries(result.map(({ key, ...rest }) => [key, { key, ...rest }]));
        }
        return <ListItemButton
          key={index}
          onClick={() => handleOpenConfirmation(item)}
          sx={{
            bgcolor: '#fdfdfd',
            borderBottom: '1px solid #33ae33',
            ":hover": {
              bgcolor: '#33ae3319', borderBottom: '1px solid #33ae33'
            },
            ":nth-of-type(even)": {
              bgcolor: '#f4f4f4',
              ":hover": {
                bgcolor: '#33ae3319', borderBottom: '1px solid #33ae33'
              },
            },
          }}
        >
          <Grid container spacing={1}>
            <Grid item xs={1}>
              <Typography variant="caption" color="text.secondary">
                No.
              </Typography>
              <Typography variant="body2" sx={{ fontSize: 14.5, mt: 1 }}>
                {index+1}.
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="caption" color="text.secondary">
                Train Speed
              </Typography>
              <Typography variant="body2" sx={{ fontSize: 14.5, mt: 1 }}>
                {displayItem['train_speed']?.displayValue} {displayItem['train_speed']?.unit}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="caption" color="text.secondary">
                Air Temp
              </Typography>
              <Typography variant="body2" sx={{ fontSize: 14.5, mt: 1 }}>
                {displayItem['temperature_air']?.displayValue != null
                  ? `${displayItem['temperature_air'].displayValue} ${displayItem['temperature_air']?.unit ?? ""}`
                  : "-"}
              </Typography>
            </Grid>            
            <Grid item xs={2}><br /><Button onClick={(e) => { e.stopPropagation(); handleOpenParamsDialog(item) }} color="primary" sx={{ color: '#388e3c' }}><ViewListOutlinedIcon /></Button></Grid>
            <Grid item xs={2}><br /><Button onClick={(e) => { e.stopPropagation(); handleOpenResultDialog(JSON.stringify(item)) }} color="primary" sx={{ color: '#388e3c' }}><QueryStats /></Button></Grid>
            <Grid item xs={1}><br /><Button onClick={(e) => { e.stopPropagation(); handleClickOpen(item) }} color="error" sx={{ color: '#388e3c' }}><RemoveCircleOutlineIcon color="error" /></Button></Grid>
          </Grid>
        </ListItemButton>
      })}
      {(selectedItemResults && selectedItemResults.length > 0 && dialogueDisplay) && (
        <ReusableDialog open={dialogueDisplay} cancelText='Close' title='Input Parameter: Global' content={<DisplayDialog data={selectedItemResults} />} onCancel={() => handleCloseDialog()} />
      )}
      <ConfirmationAlert open={open} handleClose={handleClose} handleSubmit={handleDelete}
        message='This action will clear configuration calculations from history. This cannot be undone.'
        title='Are you sure you want to reset?'
      />
      <ConfirmationAlert open={isChange} handleClose={handleCloseConfirmation} handleSubmit={handleUpdateConfig}
        message='This action change configuration calculations. This cannot be undone.'
        title='Are you sure you want to change configuration?'
      />
    </>
  );
}

interface FormDialogProps {
  open: boolean,
  setFormOpen: (value: boolean) => void,
  isEdit: boolean,
  setIsEdit: (value: boolean) => void
  storedInputParams: ParameterGroup[]
}

// fieldRules.ts

const FormDynamic = ({ open, setFormOpen, isEdit, setIsEdit, storedInputParams }: FormDialogProps) => {
  const [paramsval, setParamsval] = useState<ParameterGroup[]>([]);
  const [formValues, setFormValues] = useState<FormValues>({});
  const paramState = useInputParamState()
  const permanentState = useAppPermanentState();
  const network = useNetwork()
  const { authState } = useOktaAuth();
  const accessToken = authState?.accessToken?.accessToken || '';
  const storedData = useStoredParameters() as FormValues[]
  const mode = useMode()
  const onlineNetworks = useOnlineNetworks()

  const dependencyGraph = useMemo(
    () => buildDependencyGraphs(storedInputParams),
    [storedInputParams]
  );

  const setValueDependencyGraph = useMemo(
    () => buildSetValueDependencyGraph(storedInputParams),
    [storedInputParams]
  );

  const paramsRules = useMemo(
    () =>
      storedInputParams.length > 0
        ? buildRulesMap(storedInputParams)
        : {},
    [storedInputParams]
  );
  const params =
    network.id
      ? storedData.find(
        (data) => data.id === network.id && data.checked
      ) ?? {}
      : {};

    

  const metadataValues = useMemo(
    () =>
      buildValuesForNetwork(
        onlineNetworks,
        network.id,
        storedInputParams
      ),
    [onlineNetworks, network.id, storedInputParams]
  );
  
  const onlineNetworkFieldCodes = useMemo(
    () => Object.keys(metadataValues),
    [metadataValues]
  );

  useEffect(() => {
    setParamsval(storedInputParams);

    const defaults = buildDefaultsFromSchema(storedInputParams);

    const isEditingExistingValues =
      isEdit && open && params;

    const initialValues: FormValues =
      isEditingExistingValues
        ? {
          ...defaults,
          ...params
        }
        : {
          ...defaults,
          ...metadataValues
        };

    setFormValues(initialValues);
    setErrors({});
  }, [
    open,
    storedInputParams,
    isEdit,
    metadataValues
  ]);

  const [errors, setErrors] = useState<Record<string, ValidationMessage | undefined>>({});


  const handleChange = (field: string, value: any) => {
    setFormValues((prev) => {
      let newValues = { ...prev, [field]: value };

      newValues = applySetValueRules(
        field,
        newValues,
        paramsRules,
        setValueDependencyGraph
      );

      const nextErrors: Record<string, ValidationMessage | undefined> = {};

      nextErrors[field] = validateField(field, value, newValues, paramsRules) ?? undefined;

      dependencyGraph[field]?.forEach(depField => {
        nextErrors[depField] =
          validateField(depField, newValues[depField], newValues, paramsRules) ?? undefined
      });

      setErrors(prev => ({ ...prev, ...nextErrors }));

      return newValues;
    });
  };

  const isFormValid =
    !Object.values(errors).some(err => err?.type === 1);


  const handleCancel = () => {
    setFormOpen(false)
    setIsEdit(false)
  }

  const formSubmit = async () => {
    let firstCoord = [0,0]
    if(mode === 'offline') 
      firstCoord = networkData.network[0].centerGeoPoint.coordinates;


    const networkDetails = {
      network_id: mode === 'offline' ? (getNetworkName(network.id) ?? "unknown-network") : (network.name ?? "unknown-network"),
      coords: {latitude: firstCoord[1], longitude: firstCoord[0]},
      section_id: "global",
    };

    const response = await updateInputParameters(paramState, permanentState, { id: network.id, ...formValues }, accessToken, false, null, network.id, storedInputParams, networkDetails)
    if (response.status === "successful" && response.errors === '') {
      setFormOpen(false);
      setFormValues(formValues)
      setIsEdit(false)
    }
  }

  return (
    <>
      <Dialog open={open} >
        <DialogTitle>Global Setting for Trackstability</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Add the input parameters to view the Trackstability on the map
          </DialogContentText>
          <div>
            <DynamicInputParameter 
              dynamicRules={paramsRules} 
              errors={errors} 
              isGlobal={true} 
              params={paramsval} 
              formValues={formValues} 
              handleChange={handleChange} 
              panel='usage' 
              onlineNetworkFieldCodes={
                isEdit ? [] : onlineNetworkFieldCodes
              }
            />
          </div>
          <div>
            {Object.values(errors).some(e => e?.type === 1) && (
              <p style={{ color: 'red' }}>
                *There are blocking errors in the form. Please fix them to continue.
              </p>
            )}

            {Object.values(errors).some(e => e?.type === 2) &&
              !Object.values(errors).some(e => e?.type === 1) && (
                <p style={{ color: 'orange' }}>
                  *There are warnings in the form. You may continue.
                </p>
              )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color='error' endIcon={<Close />} onClick={() => handleCancel()} >Cancel</Button>
          <Button variant="outlined" disabled={!isFormValid} onClick={formSubmit} endIcon={<QueryStats />}>Submit Settings</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

type data = {
  [key: string]: any
}


interface DisplayDialogProps {
  data: data[];
}

function InfoHint({ item }: { item: any }) {
  const theme = useTheme();
  const isTouchDevice =
    typeof window !== "undefined" &&
    ("ontouchstart" in window || navigator.maxTouchPoints > 0);
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.down("md"));
  const usePopover = isTouchDevice || isTabletOrMobile;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  if (!item.hint) return null;

  // shared content
  const content = (
    <Box
      sx={{
        p: 1.5,
        fontSize: 12,
        width: {
          xs: "90vw",
          sm: 300,
        },
        maxHeight: 400,
        overflowY: "auto",
      }}
      dangerouslySetInnerHTML={{ __html: item.hint }}
    />
  );

  // MOBILE → Popover
  if (usePopover) {
    return (
      <>
        <IconButton
          onClick={handleOpen}
          size="small"
          sx={{ ml: 0.5, color: "#2196f3" }}
        >
          <InfoOutlined fontSize="small" />
        </IconButton>

        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          {content}
        </Popover>
      </>
    );
  }

  // DESKTOP → Tooltip
  return (
    <Tooltip
      placement='right-end'
      arrow
      title={content}
      slotProps={{
        tooltip: {
          sx: {
            maxWidth: 320, // controls tooltip container width
          },
        },
      }}
    ><InfoOutlined style={{ color: '#2196f3', marginLeft: '5px' }} /></Tooltip>
  );
}

export const DisplayDialog = ({ data }: DisplayDialogProps) => {
  return (
    <Grid container spacing={2}>
      {data.map((item, index) => {
        return (
          <Grid item xs={6} key={index}>
            <Typography
              variant="subtitle2"
              sx={{ wordWrap: 'break-word', overflowWrap: 'break-word' }}
            >
              {item.label ?? ''}
              {item.hint && <InfoHint item={item} />}
            </Typography>
            <Typography color="primary" variant="body1">
              {item.displayValue === null
                ? "-"
                : item.displayValue === 0
                  ? "0"
                  : `${item.displayValue} ${item.unit ?? ""}`.trim()}
            </Typography>
          </Grid>
        );
      })}

    </Grid>

  );
};

export const DisplayOverview = () => {
  const storedData = useStored()
  const network = useNetwork()
  const [dialogOpen, setDialogOpen] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const storedInputParams = useInputParams()
  const responseSchema = useResponseSchema()

  const handleOpen = () => setDialogOpen(true)

  const handleClose = () => setDialogOpen(false)

  const section = (() => {
    if (!storedData?.length || !network?.id) return undefined;

    const matchingData = storedData.find(d => d.id === network.id && d.checked === true);
    const firstSection = matchingData?.sections?.[0];

    if (!firstSection) return undefined;

    return firstSection;
  })();

  const result = (() => {
    if (!storedData?.length || !network?.id) return [];

    const matchingData = storedData.find(
      d => d.id === network.id && d.checked === true
    );

    const firstSection = matchingData?.sections?.[0];
    if (!firstSection) return [];

    // Map for fast lookup
    const schemaMap = new Map(responseSchema.map(s => [s.code, s]));

    return Object.entries(firstSection)
      .filter(([key]) => schemaMap.has(key))
      .map(([key, value]) => {
        const schema = schemaMap.get(key)!;

        return {
          key: key,
          code: schema.code,
          label: schema.label,
          hint: schema.hint,
          unit: schema.unit,
          value: value,
          displayValue: value,
        };
      });
  })();


  return <>
    {(section && Object.keys(section).length > 0 && network.id) &&
      <Box
        sx={{
          p: 3,
          border: '1px solid #ddd',
          borderRadius: 2,
          boxShadow: 1,
          maxWidth: 400,
          margin: '0 auto',
          backgroundColor: '#fafafa',
        }}
      >
        <Grid >
          <h2 style={{ color: 'green', fontWeight: 'bold' }}>Calculation Results</h2>
          <Grid container spacing={1} >
            {responseSchema && responseSchema.length > 0 &&
              <Grid item xs={6}><Typography variant="caption">{responseSchema[0].label}
                {responseSchema[0].hint && <Tooltip
                  arrow
                  title={
                    <Box
                      sx={{ fontSize: 12 }}
                      dangerouslySetInnerHTML={{ __html: responseSchema[0].hint }}
                    />
                  }
                ><InfoOutlined style={{ color: '#2196f3', marginLeft: '5px' }} /></Tooltip>}
              </Typography><br />
                <Typography variant="body1" sx={{ color: 'green' }}>{section[responseSchema[0].code]}  {responseSchema[0].unit} </Typography></Grid>
            }
          </Grid>
          <Grid container marginTop={1} spacing={1}>
            <Grid item xs={12}><Button sx={{
              textTransform: "none",
              borderRadius: 2,
              padding: "8px 16px",
              fontWeight: "bold",
              color: network.id === '' ? "gray" : "primary.main",
              borderColor: network.id === '' ? "gray" : "primary.main",
              "&:hover": {
                borderColor: "primary.dark",
                backgroundColor: "action.hover",
              },
            }} endIcon={<ReadMoreOutlined />} variant='outlined' onClick={handleOpen} disabled={network.id !== '' ? false : true}>View more</Button></Grid>
          </Grid>
          {section?.recommendations && (section?.recommendations).length > 0 && <>
            <Grid container marginTop={1} spacing={1}>
              <Grid item xs={12}>
                <Button sx={{
                  textTransform: "none",
                  borderRadius: 2,
                  padding: "8px 16px",
                  fontWeight: "bold",
                  color: network.id === '' ? "gray" : "#8d42a8",
                  borderColor: network.id === '' ? "gray" : "#8d42a8",
                  "&:hover": {
                    borderColor: "primary.dark",
                    backgroundColor: "action.hover",
                  },
                }} endIcon={<Recommend sx={{
                  animation: "pulse 1s ease-in-out infinite",
                  "@keyframes pulse": {
                    "0%": { transform: "scale(1)" },
                    "50%": { transform: "scale(1.5)" },
                    "100%": { transform: "scale(1)" },
                  },
                }} />} variant='outlined' onClick={() => setPopupOpen(true)} disabled={network.id !== '' ? false : true}>
                  <Typography sx={{
                    background: "linear-gradient(90deg, #390054, #9cce6e, #4a1f5e)",
                    backgroundSize: "200% 100%",
                    animation: "shine 2s linear infinite",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    "@keyframes shine": {
                      "0%": { backgroundPosition: "-200% 0" },
                      "100%": { backgroundPosition: "200% 0" },
                    },
                  }}>See Recommendations</Typography>
                </Button>
              </Grid>
            </Grid>
            {popupOpen && <AlertDialogSlide data={section?.recommendations} open={popupOpen} setOpen={setPopupOpen} />}</>
          }
        </Grid>
        {(Object.keys(storedInputParams).length > 0 && result.length > 0 && dialogOpen) && <ReusableDialog open={dialogOpen} cancelText='Close' title='Trackstability calculation Result: Global' content={<DisplayDialog data={result} />} onCancel={() => handleClose()} />}
      </Box>
    }
  </>
}

export const OnlineNetworksDropdown = () => {
  const networks = useOnlineNetworks();
  const [networkId, setNetworkId] = useState("");
  const paramState = useInputParamState()
  const applicationState = useApplicationState()
  const accessToken = useAccessToken()
  const storedInputParams = useInputParams()
  const permenantState = useAppPermanentState()
  const networkLoaded = useNetworkLoaded()

  const handleChange = async (selectedId: string) => {
    setNetworkId(selectedId);

    const selectedNetwork = networks?.find(
      (network) => network.network_uuid === selectedId
    );

    if (!selectedNetwork) return;
    updateNetwork(paramState, {id: selectedId, name: selectedNetwork.name})
    const result = await getNetworkFeatures(paramState, applicationState, accessToken, {id: selectedNetwork.network_uuid, min_lat: selectedNetwork.bbox.min_lat, max_lat: selectedNetwork.bbox.max_lat, min_lon: selectedNetwork.bbox.min_lon, max_lon: selectedNetwork.bbox.max_lon}, selectedNetwork.name)
    const network_name = selectedNetwork.name
    if (!networkLoaded[networkId] === true && result) 
      getSavedParameterDetails(paramState, permenantState, network_name, accessToken, storedInputParams)
  };

  return (
    <FormControl variant="standard" fullWidth>
      <InputLabel id="select-network-label">Select Network</InputLabel>

      <Select
        labelId="select-network-label"
        id="select-network"
        value={networkId}
        onChange={(event) => handleChange(event.target.value)}
        label="Select Network"
      >
        {networks?.map((network) => (
          <MenuItem
            key={network.network_uuid}
            value={network.network_uuid}
          >
            {network.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};



